import { Layout } from 'antd';
import { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import type { Dispatch } from 'redux';

import { ConfigContext } from 'app/context/ConfigContext/ConfigContext';
import { UserContext } from 'app/context/UserContext/UserContext';
import { UsersnapProvider } from 'app/context/UsersnapContext/UsersnapContext';
import { initApp } from 'app/redux/actions/navigation';

import { HotelMigration } from './pages/HotelMigration/HotelMigration';

type HotelMigrationAppProps = {
  appReady: boolean;
  init: () => void;
};

const HotelMigrationAppComponent = ({
  appReady,
  init,
}: HotelMigrationAppProps) => {
  const { user, isAdmin } = useContext(UserContext);
  const config = useContext(ConfigContext);

  useEffect(() => {
    init();
  }, [init]);

  if (!user || !appReady) {
    return null;
  }

  if (
    user &&
    !isAdmin &&
    (!user.hotelIds || !user.hotelIds.length) &&
    config?.appUrl
  ) {
    return <Redirect to={config.appUrl} />;
  }

  return (
    <UsersnapProvider>
      <Helmet>
        <title>Staycation - Hotel Migration</title>
      </Helmet>
      <Layout className="app">
        <Switch>
          <Route path="/hotel-migration/:hotelId" component={HotelMigration} />
          <Redirect to={`/admin`} />
        </Switch>
      </Layout>
    </UsersnapProvider>
  );
};

const mapStateToProps = (state: { navigation: { appReady: boolean } }) => ({
  appReady: state.navigation.appReady,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  init: () => dispatch(initApp('hotel-migration')),
});

export const HotelMigrationApp = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HotelMigrationAppComponent)
);
